import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
    standalone: false, // since you're using SharedModule
})
export class TruncatePipe implements PipeTransform {
    transform(value: string, maxLength: number = 20): string {
        if (!value) return value;

        return value.length > maxLength ? value.substring(0, maxLength) + '...' : value;
    }
}
